"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const sticky_1 = __importDefault(require("./sticky"));
const header1_main_1 = __importDefault(require("./containers/header1-main"));
const header2_nav_1 = __importDefault(require("./containers/header2-nav"));
const header3_breadcrumb_1 = __importDefault(require("./containers/header3-breadcrumb"));
const header4_section_1 = __importDefault(require("./containers/header4-section"));
const header5_title_1 = __importDefault(require("./containers/header5-title"));
const next_app_controller_reducers_sagas_main_reducer_r_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-r");
const persistedInfo_1 = require("./persistedInfo");
class Header extends react_1.Component {
    constructor() {
        super(...arguments);
        this.componentDidMount = () => {
            const { checkCPAndSetZones, setCpParams } = this.props;
            const { geo } = (0, persistedInfo_1.getPersistedData)();
            if (!geo) {
                checkCPAndSetZones({ cp: '' });
            }
            else {
                setCpParams(Object.assign({}, geo));
            }
        };
    }
    render() {
        const { logged, userName, userType, contextLoaded, mainOptions, navSections, segmentMenu, burgerSections, burgerOptions, account, pills, breadcrumbs, rehidrate, } = this.props;
        if (process.env.NEXT_PUBLIC_WEB_VIEW === 'true') {
            return null;
        }
        if (mainOptions) {
            return (react_1.default.createElement("header", { className: `header r-${rehidrate}` },
                react_1.default.createElement(sticky_1.default, null,
                    react_1.default.createElement(header1_main_1.default, { mainOptions: mainOptions, navSections: navSections, segmentMenu: segmentMenu, burgerSections: burgerSections, burgerOptions: burgerOptions, accountSections: account, logged: logged, userName: userName, userType: userType, breadcrumb: breadcrumbs, rehidrate: rehidrate, contextLoaded: !!contextLoaded })),
                react_1.default.createElement(header2_nav_1.default, { navSections: navSections, segmentMenu: segmentMenu, rehidrate: rehidrate, logged: logged }),
                react_1.default.createElement(header3_breadcrumb_1.default, { breadcrumb: breadcrumbs }),
                react_1.default.createElement(header4_section_1.default, { pills: pills }),
                react_1.default.createElement(header5_title_1.default, { theme: breadcrumbs && breadcrumbs['title-theme']
                        ? breadcrumbs['title-theme']
                        : null, title: breadcrumbs && breadcrumbs.title ? breadcrumbs.title : null })));
        }
        return null;
    }
}
const mapStateToProps = (state) => ({
    rehidrate: state.main.rehidrate,
    navSections: state.header.navSections,
    segmentMenu: state.header.segmentMenu,
    burgerSections: state.header.burgerSections,
    burgerOptions: state.header.burgerOptions,
    account: state.header.account,
    logged: state.main.logged,
    contextLoaded: state.main.context.tabId,
    userName: state.main.context.userName,
    userType: state.main.context.userType,
});
const mapDispatchToProps = (dispatch) => ({
    setCpParams: data => dispatch(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setCpParams(data)),
    setContextData: newData => dispatch(next_app_controller_reducers_sagas_main_reducer_r_1.actions.setContextData(newData)),
    checkCPAndSetZones: (data) => dispatch(next_app_controller_reducers_sagas_main_reducer_r_1.actions.checkCPAndSetZones(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Header);
//# sourceMappingURL=index.js.map